var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTeamwork(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 107.467,
    height: 111.831,
    viewBox: "0 0 107.467 111.831",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_50",
    "data-name": "Layer 50",
    transform: "translate(-0.01 -0.006)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_49",
    "data-name": "Path 49",
    d: "M174.843,349.243l-.022-21.149-9.627.01.007,6.638-21.633.022a4.184,4.184,0,0,0-4.181,4.189l.011,10.326a10.155,10.155,0,0,0,10.166,10.145l15.131-.016a10.157,10.157,0,0,0,10.147-10.165Z",
    transform: "translate(-111.344 -262.097)",
    fill: "#0a9bd8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50",
    "data-name": "Path 50",
    d: "M144.76,355.842a11.362,11.362,0,0,1-11.361-11.35l-.011-10.326a5.4,5.4,0,0,1,5.386-5.4l20.426-.02-.005-5.431a1.207,1.207,0,0,1,1.205-1.208l9.627-.01h0a1.207,1.207,0,0,1,1.207,1.206l.022,21.149A11.364,11.364,0,0,1,159.9,355.828l-15.132.016Zm16.85-31.321.006,5.431a1.207,1.207,0,0,1-1.206,1.208l-21.633.023a2.982,2.982,0,0,0-2.975,2.981l.011,10.326a8.948,8.948,0,0,0,8.948,8.939h.01l15.131-.016a8.951,8.951,0,0,0,8.942-8.958l-.02-19.942Z",
    transform: "translate(-106.551 -257.309)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51",
    "data-name": "Path 51",
    d: "M203.576,459.777a7.142,7.142,0,0,0-7.143-6.854l-1.9,0a7.14,7.14,0,0,0-7.129,6.869Z",
    transform: "translate(-149.699 -361.818)",
    fill: "#efcdb1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52",
    "data-name": "Path 52",
    d: "M182.6,456.207a1.207,1.207,0,0,1-1.207-1.252,8.32,8.32,0,0,1,8.333-8.031l1.9,0h.009a8.319,8.319,0,0,1,8.341,8.013,1.207,1.207,0,0,1-1.2,1.255l-16.176.017Zm9.041-6.871h-.006l-1.9,0a5.913,5.913,0,0,0-5.744,4.454l13.4-.014A5.913,5.913,0,0,0,191.644,449.336Z",
    transform: "translate(-144.902 -357.024)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53",
    "data-name": "Path 53",
    d: "M222.732,409.649a1.207,1.207,0,0,1-1.207-1.205l-.009-8.355a1.207,1.207,0,0,1,1.206-1.208h0a1.207,1.207,0,0,1,1.207,1.206l.009,8.355a1.207,1.207,0,0,1-1.206,1.208Z",
    transform: "translate(-176.954 -318.645)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54",
    "data-name": "Path 54",
    d: "M203.561,492.517l-.005-5.238c0-.095,0-.187-.007-.282l-16.176.017c0,.094-.007.187-.007.282l.005,5.238a7.141,7.141,0,0,0,7.15,7.136l1.9,0A7.143,7.143,0,0,0,203.561,492.517Z",
    transform: "translate(-149.672 -389.039)",
    fill: "#8a5d3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55",
    "data-name": "Path 55",
    d: "M189.718,496.085a8.348,8.348,0,0,1-8.349-8.343l-.005-5.236c0-.115,0-.227.008-.342a1.207,1.207,0,0,1,1.2-1.146L198.752,481h0a1.207,1.207,0,0,1,1.205,1.144c.006.115.009.227.009.342l.005,5.238a8.35,8.35,0,0,1-8.341,8.358l-1.9,0Zm-5.94-12.656,0,4.313a5.935,5.935,0,0,0,5.936,5.93h.006l1.9,0a5.936,5.936,0,0,0,5.93-5.942l0-4.313Z",
    transform: "translate(-144.876 -384.248)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56",
    "data-name": "Path 56",
    d: "M267.732,366.191l.009,8.867",
    transform: "translate(-213.873 -292.531)",
    fill: "#272d33"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57",
    "data-name": "Path 57",
    d: "M262.948,371.471a1.207,1.207,0,0,1-1.207-1.205l-.009-8.867a1.207,1.207,0,0,1,1.205-1.208h0a1.207,1.207,0,0,1,1.207,1.206l.009,8.867a1.207,1.207,0,0,1-1.205,1.208Z",
    transform: "translate(-209.08 -287.738)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_58",
    "data-name": "Path 58",
    d: "M277.3,297.815l-.005-5.268a2.358,2.358,0,0,0-2.361-2.356l-4.911.005a2.36,2.36,0,0,0-2.356,2.361l.006,5.268Z",
    transform: "translate(-213.818 -231.818)",
    fill: "#efcdb1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59",
    "data-name": "Path 59",
    d: "M262.875,294.238a1.207,1.207,0,0,1-1.207-1.205l-.006-5.268a3.569,3.569,0,0,1,3.56-3.569l4.911-.005h0a3.569,3.569,0,0,1,3.566,3.562l.005,5.268a1.207,1.207,0,0,1-1.206,1.208l-9.627.01Zm7.263-7.634h0l-4.911.005a1.153,1.153,0,0,0-1.15,1.153l0,4.061,7.213-.007,0-4.061a1.153,1.153,0,0,0-1.153-1.15Z",
    transform: "translate(-209.025 -227.025)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60",
    "data-name": "Path 60",
    d: "M347.408,265.777,327.5,258.634,324.25,267.7l6.248,2.242L323.192,290.3a4.184,4.184,0,0,0,2.525,5.352l9.719,3.488a10.155,10.155,0,0,0,12.988-6.128l5.111-14.242a10.157,10.157,0,0,0-6.127-12.991Z",
    transform: "translate(-257.981 -206.608)",
    fill: "#89c45e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61",
    "data-name": "Path 61",
    d: "M334.069,296.149a11.308,11.308,0,0,1-3.827-.669l-9.719-3.488a5.4,5.4,0,0,1-3.254-6.9l6.9-19.225-5.112-1.834a1.207,1.207,0,0,1-.728-1.543l3.251-9.061a1.207,1.207,0,0,1,1.543-.728l19.907,7.143a11.376,11.376,0,0,1,6.856,14.534l-5.111,14.242a11.382,11.382,0,0,1-10.706,7.525Zm-13.061-33.976,5.112,1.834a1.207,1.207,0,0,1,.728,1.544l-7.307,20.361a2.982,2.982,0,0,0,1.8,3.809l9.719,3.488a8.958,8.958,0,0,0,11.445-5.4l5.111-14.242a8.96,8.96,0,0,0-5.4-11.446l-18.77-6.735Z",
    transform: "translate(-253.194 -201.814)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62",
    "data-name": "Path 62",
    d: "M439.495,356.051a7.142,7.142,0,0,0-8.868,4.4l-.644,1.792a7.14,7.14,0,0,0,4.048,9.034Z",
    transform: "translate(-343.152 -284.166)",
    fill: "#efcdb1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_63",
    "data-name": "Path 63",
    d: "M429.209,367.661a1.205,1.205,0,0,1-.451-.087,8.32,8.32,0,0,1-4.733-10.561l.644-1.792a8.32,8.32,0,0,1,10.368-5.142,1.207,1.207,0,0,1,.773,1.559l-5.463,15.226a1.207,1.207,0,0,1-1.136.8Zm3.3-15.561a5.915,5.915,0,0,0-5.569,3.935l-.644,1.793a5.913,5.913,0,0,0,2.245,6.913l4.526-12.614q-.279-.027-.557-.027Z",
    transform: "translate(-338.33 -279.343)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64",
    "data-name": "Path 64",
    d: "M391.1,366.708a1.206,1.206,0,0,1-.408-.071l-7.864-2.822a1.207,1.207,0,1,1,.815-2.272l7.864,2.822a1.207,1.207,0,0,1-.408,2.343Z",
    transform: "translate(-305.179 -288.761)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65",
    "data-name": "Path 65",
    d: "M462.446,359.219l-4.93-1.77c-.089-.032-.177-.06-.267-.088l-5.464,15.225c.087.036.173.07.261.1l4.93,1.77a7.141,7.141,0,0,0,9.135-4.311l.644-1.793a7.143,7.143,0,0,0-4.31-9.134Z",
    transform: "translate(-360.906 -285.477)",
    fill: "#8a5d3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_66",
    "data-name": "Path 66",
    d: "M454.6,371.3a8.357,8.357,0,0,1-2.827-.5l-4.93-1.77c-.109-.039-.213-.079-.318-.123a1.207,1.207,0,0,1-.672-1.522l5.463-15.224a1.207,1.207,0,0,1,1.487-.747c.11.033.216.068.325.107l4.93,1.77a8.359,8.359,0,0,1,5.039,10.679l-.644,1.793A8.364,8.364,0,0,1,454.6,371.3Zm-6.071-4.224,4.059,1.457a5.934,5.934,0,0,0,7.592-3.582l.644-1.792a5.943,5.943,0,0,0-3.582-7.592l-4.059-1.456Z",
    transform: "translate(-356.112 -280.69)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67",
    "data-name": "Path 67",
    d: "M365.251,316.532l8.346,2.995",
    transform: "translate(-291.777 -252.861)",
    fill: "#272d33"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_68",
    "data-name": "Path 68",
    d: "M368.8,315.939a1.207,1.207,0,0,1-.408-.071l-8.345-2.995a1.207,1.207,0,1,1,.815-2.272l8.346,2.995a1.207,1.207,0,0,1-.408,2.343Z",
    transform: "translate(-286.983 -248.066)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69",
    "data-name": "Path 69",
    d: "M306.785,251.013l-4.958-1.779a2.358,2.358,0,0,0-3.017,1.423l-1.659,4.622a2.359,2.359,0,0,0,1.423,3.016l4.959,1.779Z",
    transform: "translate(-237.264 -198.987)",
    fill: "#efcdb1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_70",
    "data-name": "Path 70",
    d: "M298.745,256.488a1.2,1.2,0,0,1-.408-.071l-4.959-1.779a3.566,3.566,0,0,1-2.152-4.559l1.659-4.622a3.568,3.568,0,0,1,4.559-2.152l4.959,1.779a1.207,1.207,0,0,1,.728,1.543l-3.251,9.061a1.207,1.207,0,0,1-1.136.8Zm-2.5-10.979a1.153,1.153,0,0,0-1.085.763l-1.659,4.622a1.153,1.153,0,0,0,.695,1.473l3.822,1.372,2.436-6.789-3.822-1.372A1.142,1.142,0,0,0,296.243,245.51Z",
    transform: "translate(-232.474 -194.195)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71",
    "data-name": "Path 71",
    d: "M308.016,116.83l-12.5,17.056,7.764,5.692,3.925-5.353,17.446,12.791a4.184,4.184,0,0,0,5.85-.9l6.106-8.327a10.155,10.155,0,0,0-2.185-14.195l-12.2-8.947a10.158,10.158,0,0,0-14.2,2.182Z",
    transform: "translate(-236.065 -90.011)",
    fill: "#fdc00f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72",
    "data-name": "Path 72",
    d: "M322.308,144.254a5.35,5.35,0,0,1-3.178-1.045l-16.473-12.078-3.211,4.38a1.207,1.207,0,0,1-1.687.26l-7.764-5.692a1.207,1.207,0,0,1-.26-1.687l12.5-17.056a11.377,11.377,0,0,1,15.883-2.443l12.2,8.948a11.362,11.362,0,0,1,2.445,15.881l-6.106,8.327a5.357,5.357,0,0,1-3.527,2.141A5.462,5.462,0,0,1,322.308,144.254ZM302.4,128.237a1.2,1.2,0,0,1,.713.234l17.446,12.791a2.977,2.977,0,0,0,4.164-.641l6.106-8.327a8.948,8.948,0,0,0-1.926-12.508l-12.2-8.947a8.96,8.96,0,0,0-12.51,1.924L292.4,128.846l5.817,4.264,3.211-4.38A1.206,1.206,0,0,1,302.4,128.237Z",
    transform: "translate(-231.264 -85.231)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73",
    "data-name": "Path 73",
    d: "M423.215,118.315a7.143,7.143,0,0,0,1.7,9.752l1.536,1.126a7.14,7.14,0,0,0,9.812-1.314Z",
    transform: "translate(-337.107 -94.512)",
    fill: "#efcdb1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74",
    "data-name": "Path 74",
    d: "M425.84,127a8.334,8.334,0,0,1-4.942-1.626l-1.536-1.126a8.32,8.32,0,0,1-1.984-11.4,1.207,1.207,0,0,1,1.714-.3l13.045,9.564a1.207,1.207,0,0,1,.232,1.724A8.314,8.314,0,0,1,425.84,127Zm-7.057-11.685a5.914,5.914,0,0,0,2.006,6.986l1.536,1.126a5.913,5.913,0,0,0,7.266-.188Z",
    transform: "translate(-332.27 -89.718)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75",
    "data-name": "Path 75",
    d: "M407.125,178.008a1.207,1.207,0,0,1-.972-1.921l4.94-6.738a1.207,1.207,0,0,1,1.946,1.428l-4.94,6.738A1.2,1.2,0,0,1,407.125,178.008Z",
    transform: "translate(-324.265 -134.888)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_76",
    "data-name": "Path 76",
    d: "M431.32,84.568l-3.1,4.224c-.056.076-.108.152-.161.231l13.045,9.564c.06-.073.116-.146.172-.222l3.1-4.224a7.14,7.14,0,0,0-1.537-9.984L441.3,83.031A7.143,7.143,0,0,0,431.32,84.568Z",
    transform: "translate(-341.955 -65.221)",
    fill: "#8a5d3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77",
    "data-name": "Path 77",
    d: "M436.316,95.019a1.2,1.2,0,0,1-.713-.234l-13.045-9.565a1.207,1.207,0,0,1-.294-1.637c.063-.1.127-.188.195-.28l3.1-4.224a8.36,8.36,0,0,1,11.671-1.8l1.536,1.126a8.348,8.348,0,0,1,1.8,11.671l-3.1,4.224c-.068.093-.136.181-.209.271a1.205,1.205,0,0,1-.937.445ZM424.953,83.983l11.11,8.146,2.55-3.478a5.943,5.943,0,0,0-1.277-8.3L435.8,79.228a5.943,5.943,0,0,0-8.3,1.277Z",
    transform: "translate(-337.164 -60.445)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78",
    "data-name": "Path 78",
    d: "M356.6,187.322l5.243-7.151",
    transform: "translate(-284.87 -143.927)",
    fill: "#272d33"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79",
    "data-name": "Path 79",
    d: "M351.81,183.736a1.207,1.207,0,0,1-.972-1.92l5.243-7.151a1.207,1.207,0,1,1,1.946,1.428l-5.243,7.15A1.2,1.2,0,0,1,351.81,183.736Z",
    transform: "translate(-280.077 -139.134)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80",
    "data-name": "Path 80",
    d: "M281.326,218.108l-3.115,4.248a2.358,2.358,0,0,0,.508,3.3l3.96,2.9a2.359,2.359,0,0,0,3.3-.507l3.115-4.249Z",
    transform: "translate(-221.879 -174.233)",
    fill: "#efcdb1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_81",
    "data-name": "Path 81",
    d: "M279.271,225.426a3.538,3.538,0,0,1-2.1-.69l-3.96-2.9a3.565,3.565,0,0,1-.767-4.983l3.115-4.248a1.207,1.207,0,0,1,1.687-.26l7.764,5.692a1.207,1.207,0,0,1,.26,1.687l-3.115,4.249a3.542,3.542,0,0,1-2.333,1.415A3.641,3.641,0,0,1,279.271,225.426ZM276.792,215l-2.4,3.275a1.151,1.151,0,0,0,.248,1.609l3.96,2.9a1.152,1.152,0,0,0,1.609-.248l2.4-3.275Z",
    transform: "translate(-217.087 -169.439)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82",
    "data-name": "Path 82",
    d: "M73.656,201.764,93.28,193.88l-3.589-8.933-6.159,2.474-8.066-20.074a4.184,4.184,0,0,0-5.444-2.323l-9.582,3.85A10.155,10.155,0,0,0,54.8,182.083l5.641,14.041A10.157,10.157,0,0,0,73.656,201.764Z",
    transform: "translate(-43.186 -131.585)",
    fill: "#3d5ca9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_83",
    "data-name": "Path 83",
    d: "M65.093,198.928a11.39,11.39,0,0,1-10.544-7.134l-5.641-14.041a11.375,11.375,0,0,1,6.307-14.779l9.581-3.85a5.4,5.4,0,0,1,7.013,2.993l7.615,18.953,5.039-2.025a1.207,1.207,0,0,1,1.569.67l3.589,8.933a1.207,1.207,0,0,1-.67,1.569L69.328,198.1a11.349,11.349,0,0,1-4.235.826ZM66.8,161.15a2.961,2.961,0,0,0-1.106.215l-9.582,3.85a8.959,8.959,0,0,0-4.967,11.639l5.641,14.041a8.951,8.951,0,0,0,11.64,4.97l18.5-7.435-2.689-6.693-5.039,2.025a1.207,1.207,0,0,1-1.569-.67l-8.066-20.074A2.983,2.983,0,0,0,66.8,161.15Z",
    transform: "translate(-38.409 -126.804)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_84",
    "data-name": "Path 84",
    d: "M59.8,263.2a7.142,7.142,0,0,0,3.707-9.179l-.71-1.767a7.14,7.14,0,0,0-9.027-4.063Z",
    transform: "translate(-42.949 -197.931)",
    fill: "#efcdb1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85",
    "data-name": "Path 85",
    d: "M55.01,259.582a1.207,1.207,0,0,1-1.12-.757l-6.031-15.01a1.207,1.207,0,0,1,.713-1.586,8.32,8.32,0,0,1,10.554,4.749l.71,1.767A8.32,8.32,0,0,1,55.5,259.477a1.207,1.207,0,0,1-.492.105ZM50.616,244.2l5,12.436a5.913,5.913,0,0,0,1.984-6.992l-.71-1.767A5.913,5.913,0,0,0,50.616,244.2Z",
    transform: "translate(-38.156 -193.107)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_86",
    "data-name": "Path 86",
    d: "M101.659,256.048a1.207,1.207,0,0,1-.45-2.327l7.752-3.115a1.207,1.207,0,1,1,.9,2.24l-7.753,3.115A1.2,1.2,0,0,1,101.659,256.048Z",
    transform: "translate(-80.238 -200.125)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87",
    "data-name": "Path 87",
    d: "M16.531,266.921l4.861-1.953c.088-.035.172-.072.258-.111l-6.031-15.01c-.089.031-.176.063-.263.1L10.5,251.9a7.142,7.142,0,0,0-3.966,9.291l.71,1.767a7.143,7.143,0,0,0,9.291,3.965Z",
    transform: "translate(-4.796 -199.588)",
    fill: "#8a5d3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_88",
    "data-name": "Path 88",
    d: "M9.071,263.853a8.369,8.369,0,0,1-7.746-5.241l-.71-1.767a8.347,8.347,0,0,1,4.635-10.86l4.861-1.953c.106-.043.211-.082.32-.119a1.207,1.207,0,0,1,1.513.691l6.031,15.01a1.207,1.207,0,0,1-.615,1.546c-.1.048-.207.092-.313.135l-4.861,1.953A8.341,8.341,0,0,1,9.071,263.853Zm1.08-17.238-4,1.608a5.935,5.935,0,0,0-3.294,7.721l.71,1.767a5.936,5.936,0,0,0,7.721,3.3l4-1.608Z",
    transform: "translate(0 -194.794)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_89",
    "data-name": "Path 89",
    d: "M163.19,279.464l-8.227,3.306",
    transform: "translate(-123.786 -223.248)",
    fill: "#272d33"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90",
    "data-name": "Path 90",
    d: "M150.167,279.183a1.207,1.207,0,0,1-.45-2.327l8.227-3.306a1.207,1.207,0,0,1,.9,2.24l-8.227,3.305a1.2,1.2,0,0,1-.45.087Z",
    transform: "translate(-118.989 -218.454)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91",
    "data-name": "Path 91",
    d: "M234.761,265.733l4.888-1.964a2.358,2.358,0,0,0,1.309-3.067l-1.83-4.557a2.359,2.359,0,0,0-3.067-1.309l-4.888,1.964Z",
    transform: "translate(-184.667 -203.439)",
    fill: "#efcdb1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_92",
    "data-name": "Path 92",
    d: "M229.964,262.153a1.207,1.207,0,0,1-1.12-.757l-3.59-8.933a1.207,1.207,0,0,1,.67-1.569l4.888-1.964a3.569,3.569,0,0,1,4.637,1.979l1.83,4.557A3.569,3.569,0,0,1,235.3,260.1l-4.888,1.964A1.206,1.206,0,0,1,229.964,262.153Zm-2.02-9.47,2.689,6.693,3.769-1.514a1.153,1.153,0,0,0,.639-1.5l-1.83-4.557a1.153,1.153,0,0,0-1.5-.639Z",
    transform: "translate(-179.87 -198.651)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_93",
    "data-name": "Path 93",
    d: "M161.959,64.529l11.719,17.6,8.014-5.335-3.678-5.525,18.007-11.988a4.184,4.184,0,0,0,1.165-5.8l-5.722-8.6a10.155,10.155,0,0,0-14.081-2.826l-12.6,8.385A10.157,10.157,0,0,0,161.959,64.529Z",
    transform: "translate(-128.015 -32.236)",
    fill: "#be1e2d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94",
    "data-name": "Path 94",
    d: "M168.884,78.569a1.207,1.207,0,0,1-1.006-.538l-11.718-17.6a11.364,11.364,0,0,1,3.164-15.756l12.6-8.385a11.375,11.375,0,0,1,15.754,3.162l5.722,8.6a5.391,5.391,0,0,1-1.5,7.476l-17,11.318,3.009,4.521a1.207,1.207,0,0,1-.336,1.673l-8.014,5.335a1.207,1.207,0,0,1-.668.2ZM178.2,36.8a8.9,8.9,0,0,0-4.945,1.5l-12.6,8.385a8.951,8.951,0,0,0-2.492,12.409l11.051,16.6,6-4-3.009-4.521a1.207,1.207,0,0,1,.336-1.673L190.557,53.51a2.977,2.977,0,0,0,.829-4.13l-5.721-8.6A8.947,8.947,0,0,0,178.2,36.8Z",
    transform: "translate(-123.221 -27.464)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95",
    "data-name": "Path 95",
    d: "M178.824,53.674a7.142,7.142,0,0,0,9.742,1.758l1.585-1.055a7.14,7.14,0,0,0,2.138-9.666Z",
    transform: "translate(-142.848 -35.713)",
    fill: "#efcdb1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_96",
    "data-name": "Path 96",
    d: "M179.809,53.053a8.316,8.316,0,0,1-6.757-3.466,1.207,1.207,0,0,1,.311-1.71l13.465-8.964a1.207,1.207,0,0,1,1.7.375,8.32,8.32,0,0,1-2.5,11.3l-1.585,1.055a8.338,8.338,0,0,1-4.633,1.409Zm-3.954-3.935a5.913,5.913,0,0,0,7.25.517l1.585-1.055a5.913,5.913,0,0,0,2.321-6.888Z",
    transform: "translate(-138.055 -30.92)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_97",
    "data-name": "Path 97",
    d: "M234.651,104.173a1.207,1.207,0,0,1-1.006-.538l-4.63-6.955a1.207,1.207,0,1,1,2.009-1.337l4.63,6.955a1.207,1.207,0,0,1-1,1.876Z",
    transform: "translate(-182.782 -75.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98",
    "data-name": "Path 98",
    d: "M158.832,18.166l2.9,4.36c.052.079.106.154.161.23l13.466-8.964c-.048-.08-.1-.159-.15-.238l-2.9-4.36a7.142,7.142,0,0,0-9.9-1.988L160.82,8.262a7.143,7.143,0,0,0-1.988,9.9Z",
    transform: "translate(-125.921 -4.795)",
    fill: "#8a5d3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_99",
    "data-name": "Path 99",
    d: "M157.1,19.169a1.205,1.205,0,0,1-.971-.489c-.068-.092-.132-.183-.2-.279l-2.9-4.361a8.35,8.35,0,0,1,2.324-11.577l1.585-1.055A8.347,8.347,0,0,1,168.52,3.731l2.9,4.36c.064.1.123.19.181.289A1.207,1.207,0,0,1,171.236,10l-13.464,8.964a1.2,1.2,0,0,1-.668.2Zm4.454-16.75a5.9,5.9,0,0,0-3.279,1L156.7,4.472a5.936,5.936,0,0,0-1.652,8.231l2.389,3.59L168.9,8.658l-2.39-3.59a5.9,5.9,0,0,0-3.773-2.531,6,6,0,0,0-1.18-.119Z",
    transform: "translate(-121.127)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_100",
    "data-name": "Path 100",
    d: "M226.224,160.545l-4.913-7.381",
    transform: "translate(-176.789 -122.352)",
    fill: "#272d33"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_101",
    "data-name": "Path 101",
    d: "M221.432,156.958a1.205,1.205,0,0,1-1.006-.538l-4.913-7.381a1.207,1.207,0,1,1,2.009-1.337l4.913,7.381a1.207,1.207,0,0,1-1,1.876Z",
    transform: "translate(-171.995 -117.559)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102",
    "data-name": "Path 102",
    d: "M226.982,226.865l2.919,4.385a2.358,2.358,0,0,0,3.27.656l4.088-2.721a2.359,2.359,0,0,0,.656-3.27L235,221.53Z",
    transform: "translate(-181.32 -176.967)",
    fill: "#efcdb1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_103",
    "data-name": "Path 103",
    d: "M227.075,228.714a3.564,3.564,0,0,1-2.973-1.589l-2.919-4.385a1.207,1.207,0,0,1,.336-1.673l8.014-5.334a1.207,1.207,0,0,1,1.673.336l2.919,4.385a3.566,3.566,0,0,1-.992,4.943l-4.088,2.721A3.545,3.545,0,0,1,227.075,228.714Zm-3.215-6.306,2.251,3.381a1.153,1.153,0,0,0,1.6.32l4.088-2.721a1.153,1.153,0,0,0,.32-1.6l-2.251-3.381Z",
    transform: "translate(-176.525 -172.174)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamwork);
export default __webpack_public_path__ + "static/media/teamwork.e42a28fa623355008c57d4bc2ac3c3a2.svg";
export { ForwardRef as ReactComponent };